import { Hotel } from "../url";
import HttpService from "@/common/ApiService";
import configuration from "@/../public/urlConfig.json";
import vue from "vue";
const http = new HttpService(vue.prototype.$config.tourBaseAddress, {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
    'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
    'withCredentials': 'true'
});
const factory = () => ({ rooms: null, arrivalDate: null, departureDate: null, guests: null });
// require("linqjs");

export default {
    namespaced: true,

    state: factory(),

    mutations: {
        StoreRequest(state, params) {
            state.rooms = params.rooms;
            state.arrivalDate = params.arrivalDate;
            state.departureDate = params.departureDate;
            state.guests = params.guests;
        },

        ResetState(state) {
            Object.assign(state, factory());
        }
    },

    getters: {
        GetReservedRoom(state) {
            return state.rooms;
        },

        GetReservedDate(state) {
            return {
                arrivalDate: state.arrivalDate,
                departureDate: state.departureDate
            }
        },

        GetRequest(state) {
            return {
                departureDate: state.departureDate,
                arrivalDate: state.arrivalDate,
                guests: state.guests,
                rooms: state.rooms,
            };
        },

        GetTotalPassengers(state){
            return {
                adults: state.guests?.sum((t) => t.adults),
                children: state.guests?.sum((t) => t.children),
                infants: state.guests?.sum((t) => t.infants)
            }
        }
    },

    actions: {

        async AvailableRooms(context, params) {

            const response = await http.Post(Hotel.AVILABLE_URL, params);

            return response.data.data;
        },

        StoreRequest(context, params) {
            context.commit("StoreRequest", params);
        },

        async InitialReserve(context, params) {

            const response = await http.Post(Hotel.INITIAL_RESERVE_URL, params, {
                headers: { pragma: params.token }
            });

            context.commit("SetReservedRooms", response.data);
            return response.data;
        },

        async FinalReserve(context, params) {
            const response = await http.Post(Hotel.FINAL_RESERVE_URL, params, {
                headers: { pragma: params.token }
            });

            context.commit("SetReservedRooms", response.data);
            return response.data;
        },

        ResetState(context) {
            context.commit("ResetState");
        },


        async GetHotelList() {

            const response = await http.Get('BaseInfo/GetHotelList');
            return response.data.data;
        },
        
        async GetDestinationList() {

            const response = await http.Get('BaseInfo/GetDestinationsInfo');
            return response.data.data;
        },
        async GetDariushHotelNewsList() {

            const response = await http.Get('Hotel/GetDariushHotelNews');
            return response.data.data;
        },
    }
}